module.exports = __webpack_public_path__ + "static/media/3dchart_gray.970a8378.png";